module.exports = __webpack_public_path__ + "img/11.98a210b5.jpg";